import { render, staticRenderFns } from "./PageKioskDevice.vue?vue&type=template&id=14408f1f&"
import script from "./PageKioskDevice.vue?vue&type=script&lang=js&"
export * from "./PageKioskDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14408f1f')) {
      api.createRecord('14408f1f', component.options)
    } else {
      api.reload('14408f1f', component.options)
    }
    module.hot.accept("./PageKioskDevice.vue?vue&type=template&id=14408f1f&", function () {
      api.rerender('14408f1f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/kiosk-device/PageKioskDevice.vue"
export default component.exports